// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import updateSearchFields from "@stanion/App/Handlers/AllEvents/UpdateSearchFields";
import { EventListPageContext } from "@stanion/App/Store/Selectors/xAllEventsRequestSelector";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface StaffListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const staffListPaginationStyles: StaffListPaginationStyles = {
};

const styles = staffListPaginationStyles;

const AllEventsListPagination = ({ updateSearchFields }: Props) => {
    const AllEventsList = useContext(EventListPageContext);
    const pagination = AllEventsList.value && AllEventsList.pagination ? AllEventsList.pagination : undefined;

    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="allEvents-PageSize"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(AllEventsListPagination),
    definition: {
        displayName: "Pagination",
        group: "All Events" as any,
        allowedContexts: ["AllEventsPage" as any],
    },
};

export default widgetModule;
